import { Grid } from "@mui/material";
import { useNavigate } from "react-router";
import Libelle from "../../../_i18n/fr.json";
import Layout from "../../../components/Layout";
import Snack from "../../../components/Snack";
import { transformUtilisateurBesseDataToModel } from "../helpers";
import UtilisateurBesseForm, {
  UtilisateurBesseFormData,
} from "../UtilisateurBesseForm";
import { useAjouterUtilisateurBesse } from "./selectors";

function AjouterUtilisateurBesse() {
  const {
    profilsBesse,
    ajouterUtilisateur,
    utilisateurFetching,
    utilisateurError,
    resetPostUtilisateur,
    utilisateurConnecte,
  } = useAjouterUtilisateurBesse();
  const handleSubmit = (values: UtilisateurBesseFormData) => {
    const transformedValues = transformUtilisateurBesseDataToModel(values);
    ajouterUtilisateur(transformedValues);
  };

  const navigate = useNavigate();
  const handlePrecedent = () => {
    navigate("/mes-utilisateurs");
  };

  const handleClose = () => {
    resetPostUtilisateur();
  };
  const renderError = (error: any) => {
    return (
      <Snack
        onClose={handleClose}
        open={true}
        variant="error"
        message={error.message}
      />
    );
  };
  const utilisateurBESSE =
    utilisateurConnecte && utilisateurConnecte.role === "BESSE";
  return (
    <Layout title={Libelle.pageUtilisateurs.ajouter.titre}>
      <div>
        <h2>{Libelle.pageUtilisateurs.ajouter.titre} Bessé</h2>
        <UtilisateurBesseForm
          profilsBesse={profilsBesse}
          onSubmit={handleSubmit}
          handlePrecedent={handlePrecedent}
          utilisateurBESSE={utilisateurBESSE}
          isFetching={utilisateurFetching}
        />
        <Grid container justifyContent="flex-end" style={{ marginTop: 12 }}>
          {utilisateurError && renderError(utilisateurError)}
        </Grid>
      </div>
    </Layout>
  );
}
export default AjouterUtilisateurBesse;
